import styled, { css } from 'styled-components';
import { StyledActions } from '../Content/Content.styles';
import { StyledPill } from '../Pill/Pill.styles';
import { Typography } from '../Typography/Typography';
import { spacing } from '../_styles/spacing';
export var StyledTitle = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTitle",
  componentId: "core-12_20_1__sc-1t2ye1d-0"
})(["display:flex;align-items:flex-start;"]);
export var StyledAssets = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAssets",
  componentId: "core-12_20_1__sc-1t2ye1d-1"
})(["margin-right:", "px;", ""], spacing.md, function (_ref) {
  var alignment = _ref.alignment;
  return css(["align-self:", ";"], alignment);
});
export var StyledTitleContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTitleContent",
  componentId: "core-12_20_1__sc-1t2ye1d-2"
})(["align-self:center;", ""], function (_ref2) {
  var $hasActions = _ref2.$hasActions;
  return $hasActions && css(["margin-right:", "px;"], spacing.lg);
});
export var StyledText = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledText",
  componentId: "core-12_20_1__sc-1t2ye1d-3"
})(["> h1,> h2,> h3{display:inline;}"]);
export var StyledTitlePill = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTitlePill",
  componentId: "core-12_20_1__sc-1t2ye1d-4"
})(["margin-left:", "px;", "{vertical-align:text-top;}"], spacing.sm, StyledPill);
export var StyledTitleActions = /*#__PURE__*/styled(StyledActions).withConfig({
  displayName: "StyledTitleActions",
  componentId: "core-12_20_1__sc-1t2ye1d-5"
})(["margin-left:auto;"]);
export var StyledSubtext = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "StyledSubtext",
  componentId: "core-12_20_1__sc-1t2ye1d-6"
})(["display:block;"]);
//# sourceMappingURL=Title.styles.js.map